import { PlayableLetterData, UIStateAction } from "./UIState";
import * as React from "react";
import { TileSlot } from "./TileSlot";
import { Letter } from "./Letter";

export function TileTray(props: {
    letters: Array<PlayableLetterData>;
    selectedTileIndex: number | null;
    trayLength: number;
    uiDispatch: (x: UIStateAction) => void;
}): React.JSX.Element {
    let elements: React.JSX.Element[] = [];
    for (let i = 0; i < props.trayLength; i++) {
        elements.push(
            <TileSlot
                key={"empty" + i}
                location={{ location: "TRAY", index: i }}
                uiDispatch={props.uiDispatch}
            />,
        );
    }

    props.letters.forEach((letter) => {
        if (letter != null && letter.grid_index == null) {
            elements[letter.tray_index] = (
                <TileSlot
                    tile={
                        <Letter
                            data={{ ...letter, highlight: false }}
                            selected={
                                letter.tray_index == props.selectedTileIndex
                            }
                            letterUpdater={(value) => {
                                props.uiDispatch({
                                    $type: "SET_BLANK_LETTER",
                                    index: letter.tray_index,
                                    value: value,
                                });
                            }}
                        />
                    }
                    key={"letter_tray" + letter.tray_index}
                    location={{ location: "TRAY", index: letter.tray_index }}
                    uiDispatch={props.uiDispatch}
                />
            );
        }
    });

    return <div className="tray">{elements}</div>;
}
